"use client";
import { JSX } from "react";
import Slider from "react-slick";

const SETTINGS = {
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  speed: 200,
  autoplay: true,
  autoplaySpeed: 3500,
  pauseOnFocus: true,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function TestimonialClient({
  renderedTestimonials,
}: {
  renderedTestimonials: JSX.Element[];
}) {
  return <Slider {...SETTINGS}>{renderedTestimonials}</Slider>;
}
